<template>
  <div>
    <FilterTable 
      :resource_name="resource_name"
      :title="title_with_date"
      :selected_date="this.$route.params.date"
      :field_definitions="field_definitions"
      :filters="{}"
      :action_buttons="action_buttons"
      :row_actions="row_actions"
      :route_root="route_root"
      :handle_row_action="handle_row_action"
      :full_text_search="false"
      :handle_action_button_click="handle_action_button_click"
      :update_flag="filter_table_update_flag"
      :update_selected_article="update_selected_article"
    />
    <el-dialog
      title="搜尋館藏相關資料"
      :visible.sync="dialog_visible"
      width="50%"
      @close="filter_table_update_flag+=1"
      center>
      <FilterTable 
        :resource_name="resource_name_article"
        :resource_api_action="'list-with-cover-image'"
        :field_definitions="field_definitions_article"
        :filters="{}"
        :action_buttons="{}"
        :row_actions="row_actions_article"
        :handle_row_action="handle_article_row_action"
        :full_text_search="true"
        :handle_action_button_click="() => {}"
        :resource_identifier="resource_identifier"
        :update_flag="filter_table_update_flag_article"
      />
    </el-dialog>
    <LoadingBlock
        :active="loading">
    </LoadingBlock>
  </div>
</template>

<script>
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import RadioWithDatePicker from '@/components/backstage/RadioWithDatePicker/RadioWithDatePicker.vue'
import api from '@/api/index'
import { mapMutations, mapGetters } from 'vuex'

export default {
  mixins: [breadcrumbMixin],
  components: {
    FilterTable,
    LoadingBlock,
    RadioWithDatePicker,
  },
  data() {
    return {
      dialog_visible: false,
      title: '本日精選資料列表',
      resource_name: 'recommended-article',
      resource_identifier: {
        name: 'review_status',
        value: '已審核',
        form: 'json'
      },
      route_root: 'front-stage-management/recommended-article-management',
      field_definitions: [
        {
          display: {
            name: '編號',
            type: 'string',
            sortable: 'custom', 
          },
          source: {
            type: 'db',
            key: 'system_id',
            data_type: 'string',
          } 
        },
        {
          display: {
            name: '類型',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'series_name',
            data_type: 'string',
          } 
        },
        {
          display: {
            name: '全宗名',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'recordgroup_name',
            data_type: 'string',
          }
        },
        {
          display: {
            name: '單件題名',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'title',
            data_type: 'string',
          }
        },
        {
          display: {
            name: '建立時間',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'article_created_time',
            data_type: 'datetime',
          }
        },
        {
          display: {
            name: '前臺開放',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'rights_open',
            data_type: 'string',
          }
        },
      ],
      field_definitions_article: [
        {
          display: {
            name: '縮圖',
            type: 'image',
            sortable: false,
          },
          source: {
            type: 'db',
            key: 'cover_image',
            data_type: 'cover_image',
          }
        },
        {
          display: {
            name: '編號',
            type: 'string',
            sortable: 'custom', 
          },
          source: {
            type: 'db',
            key: 'system_id',
            data_type: 'string',
          } 
        },
        {
          display: {
            name: '類型',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'series_name',
            data_type: 'string',
          }
        },
        {
          display: {
            name: '全宗名',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'recordgroup_name',
            data_type: 'string',
          }
        },
        {
          display: {
            name: '單件題名',
            type: 'string',
            sortable: 'custom',
          },
          source: {
            type: 'db',
            key: 'title',
            data_type: 'string',
          }
        },
      ],
      row_actions_article: {
        add: {
          label: '新增',
          action: 'add',
          enable: (row) => this.check_row('add', row)
        },
        delete: {
          label: '移除',
          action: 'delete',
          enable: (row) => this.check_row('delete', row)
        },
      },
      resource_name_article: 'article',
      route_root_article: 'digital-resource-management',
      action_buttons: {
        add: {
          label: '新增本日精選',
          action: 'add'
        },
      },
      row_actions: {
        get: {
          label: '檢視',
          action: 'get'
        },
        delete: {
          label: '刪除',
          action: 'delete',
        },
      },
      loading: false,
      filter_table_update_flag: 0,
      filter_table_update_flag_article: 0,
      processing_add: false,
      processing_delete: false,
    }
  },
  computed: {
    ...mapGetters('selected_article', [
      'selected_article',
    ]),
    title_with_date() {
      return `${this.title} (${this.$route.params.date})`
    },
  },
  created () {
    this.permission_check({
      resource_info: { name: this.page_name.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT },
      access: { name: this.permission.VIEW },
      reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
    })
    this.clear_select_article()
    // this.date = this.$route.params.date
  },
  methods: {
      ...mapMutations('selected_article', [
        'update_selected_article',
        'clear_select_article',
      ]),
      check_row(action, row) {
        if(action == 'add') {
          return Object.values(this.selected_article).indexOf(row.system_id)===-1 ? true : false
        }else if(action == 'delete'){
          return Object.values(this.selected_article).indexOf(row.system_id)===-1 ? false : true
        }else {
          return false
        }
      },
      handle_article_row_action (action, index, row) {
        console.log('RecommendedArticleListPage (handle_article_row_action): action:' + action + ', index: ' + index + ', row: ', row)
        

        switch(action){
          case 'add':
            // terminate the function
            // if an async request is processing
            if (this.processing_add === true) {
              this.$message({
                type: 'info',
                message: '已正在新增'
              })
              return
            }
            
            // set the async state
            this.processing_add = true

            if(Object.values(this.selected_article).indexOf(row.system_id)!==-1) {
              this.notify_message(this.ERROR.LEVEL.INFO, '此筆詮釋資料已新增', '')
              this.processing_add = false
            }else {
              this.handle_add_recommended_article(this.$route.params.date, row.system_id).then(
                response => {
                  this.notify_message(this.ERROR.LEVEL.SUCCESS, '新增成功!', '')
                  console.log('(handle_add_recommended_article) result: ', response)
                  let id = response.payload.id
                  this.update_selected_article({action, id, system_id: row.system_id})
                  this.filter_table_update_flag_article += 1
                  this.processing_add = false
                }
              ).catch(
                response => {
                  this.notify_message(this.ERROR.LEVEL.ERROR, '新增失敗', '請聯絡系統管理員!')
                  this.processing_add = false
                }
              )
            }
            break
          case 'delete':
            // terminate the function
            // if an async request is processing
            if (this.processing_delete === true) {
              this.notify_message(this.ERROR.LEVEL.INFO, '已正在移除', '')
              return
            }
            
            // set the async state
            this.processing_delete = true

            if(Object.values(this.selected_article).indexOf(row.system_id)!==-1) { // 已被選取
              Object.keys(this.selected_article).forEach( id => {
                if(this.selected_article[id] == row.system_id) {
                  this.handle_delete_recommended_article(id).then(
                    string => {
                      this.notify_message(this.ERROR.LEVEL.SUCCESS, '移除成功!', '')
                      this.update_selected_article({action, id})
                      this.filter_table_update_flag_article += 1
                      this.processing_delete = false
                    }
                  ).catch(
                    response => {
                      this.notify_message(this.ERROR.LEVEL.ERROR, '移除失敗', '請聯絡系統管理員!')
                      this.processing_delete = false
                    }
                  )
                }
              })
            }else { // 沒有被選取
              this.notify_message(this.ERROR.LEVEL.INFO, '此筆詮釋資料已移除', '')
              this.processing_delete = false
            }
            break
          default:
            break
        }
      },
      handle_row_action (action, index, row) {
        console.log('FrequentlyAskedQuestionManagementPage: action:' + action + ', index: ' + index + ', row: ', row)

        switch(action){
          case 'get': 
            this.backstage_router_push({ path: `/${this.route_root_article}/${row.series_table_name}/view/${row.system_id}` })
            break
          case 'delete': 
            this.$confirm('此操作將此本日精選文章移除，是否繼續?', '提示', {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // terminate the function
              // if an async request is processing
              if (this.processing_delete === true) {
                this.notify_message(this.ERROR.LEVEL.INFO, '已正在移除', '')
                return
              }
              
              // set the async state
              this.processing_delete = true

              this.handle_delete_recommended_article(row.id).then(
                string => {
                  this.notify_message(this.ERROR.LEVEL.SUCCESS, '移除成功!', '')
                  this.update_selected_article({action, id: row.id})
                  this.filter_table_update_flag += 1
                  this.processing_delete = false
                }
              ).catch(
                response => {
                  this.notify_message(this.ERROR.LEVEL.ERROR, '移除失敗', '請聯絡系統管理員!')
                  this.processing_delete = false
                }
              )
            }).catch(() => {
              this.notify_message(this.ERROR.LEVEL.INFO, '已取消移除', '')
            });
            break
          default:
            break
        }
      },
      handle_action_button_click (action) {
        console.log('FrequentlyAskedQuestionManagementPage: action button clicked: ', action)

        switch(action){
          case 'add': 
            this.dialog_visible = true;
            break
          default:
            break
        }
      },
      async handle_add_recommended_article(selected_date, fk_article_system_id) {
        console.log('add recommended article: selected_date=', selected_date)
        console.log('add recommended article: fk_article_system_id=', fk_article_system_id)
        this.loading = true
        let result = await api.add_recommended_article(selected_date, fk_article_system_id)
        this.loading = false
        // this.filter_table_update_flag += 1
        return result
      },
      async handle_delete_recommended_article(id) {
        console.log('delete recommended article: id=', id)
        this.loading = true
        await api.delete_recommended_article(id)
        this.loading = false
        // this.filter_table_update_flag += 1
      },
    },
};

</script>

<style>
</style>
